"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardInfo = void 0;

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

exports.CardInfo = function (_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      header = _ref.header,
      _ref$headerSize = _ref.headerSize,
      headerSize = _ref$headerSize === void 0 ? 'md' : _ref$headerSize,
      content = _ref.content;
  return React.createElement("div", {
    className: "clp-card-info ".concat(className)
  }, header && React.createElement("div", {
    className: "clp-card-info__header clp-card-info__header_size_".concat(headerSize, " pb-24'")
  }, header), content && React.createElement("div", null, content));
};